<template>
  <div class="glossary-items">
    <div class="glossary-items__search-container" v-if="mobile">
          <icon name="search" size="18px" class="glossary-items__icon"></icon>
          <input type="text" class="glossary-items__search-product" placeholder="Search" v-model="product_name" >
        </div>
    <div class="glossary-items__wrapper" >
      <div class="glossary-items__alphabates">
        <ul>
          <li @click="filterByLetter('')">#</li>
          <li v-for="(letter, index) in letters" :key="index" :class="{active: letter ==selectedLetter}" @click="filterByLetter(letter)">
            <span href="javascript:void(0);" class="h6">{{ letter }}</span>
          </li>
        </ul>
      </div>
      <div class="glossary-items__inner-body">
        <div class="glossary-items__search-container" v-if="!mobile">
          <icon name="search" size="18px" class="glossary-items__icon"></icon>
          <input type="text" class="glossary-items__search-product" placeholder="Search" v-model="product_name" >
        </div>
          <accordion id="glossary-detail__accordion-container" iconSize="10px" :auto-close="true" v-for="(product, index) in filterProductsByName" :key="index"  theme="product-details">
              <span class="glossary-details__heading h3" slot="heading" v-html="product.title"></span>
              <accordion-tease class="glossary-details__tease" :on-tease-expand="onTeaseExpand" :collapsed-height="600">
                <div class="client-generated glossary-details__description" v-html="product.description"></div>
                <div class="glossary-details__view_all_link">
                  <a :href="product.viewAllLink" v-if="product.viewAllLink!=''" class="link link--secondary">View All</a>
                  </div>
                <div class="grid-container__parent">
                  <div class="grid-container__inner">
                    <product-tile v-for="p in product.products" :key="p.handle"
                      class="glossary-products flex-item"
                      :simple="true"
                      :product="p"
                      text-alignment="center"
                      :enable-simple-tile-cta="true"
                    />
                  </div>
                </div>
              </accordion-tease>
            </accordion>
      </div>
    </div>
  </div>
</template>

<script>
import AccordionGroup from '@/scripts/components/basic/AccordionGroup.vue'
import Accordion from '@/scripts/components/basic/Accordion.vue'
import AccordionTease from '@/scripts/components/basic/AccordionTease.vue'
import Icon from '@/scripts/components/basic/Icon.vue'
import VLink from '@/scripts/components/buttons/VLink.vue'
import SimpleProductTile from '@/scripts/components/product/ProductTileSimple.vue';
import ProductTileSkeleton from '@/scripts/components/product/ProductTileSkeleton.vue'
import ProductTile from '@/scripts/components/product/ProductTile.vue'

export default {
  name: 'GlossaryItems',
  components: {
    AccordionGroup,
    Accordion,
    VLink,
    AccordionTease,
    ProductTileSkeleton,
    SimpleProductTile,
    ProductTile,
    Icon
  },
  props: {
     items: {
      type: Object
    }
  },
  computed: {
    mobile () {
      return this.$mq === 'mobile'
    },
    filterProductsByName: function() {
      console.log("All product Articles", this.items.articles)
      if (this.product_name!='') {
        if(this.isLetterSearch ) {
              return this.products.filter(product =>
              product.title.toLowerCase().charAt()==this.selectedLetter.toLowerCase()
           );
        } else {
          return this.products.filter(product =>
           product.title.toLowerCase().indexOf(this.product_name.toLowerCase()) > -1
          ).sort((x,y)=>x.title.toUpperCase().localeCompare(y.title.toUpperCase()));
        }
      } else {
        return this.products.sort((x,y)=>x.title.toUpperCase().localeCompare(y.title.toUpperCase()));
      }
    }
  },
  data() {
    return {
      isActive: false,
      selectedLetter: undefined,
      isLetterSearch: false,
      product_name:'',
      products: this.items.articles,
      productHandles: this.items.articles.productHandles,
      letters : ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
      }
  },
  methods: {
     SortArray(x, y){
      return x.title.toUpperCase().localeCompare(y.title.toUpperCase());
    },
    onTeaseExpand () {
     // tell the active accordions to update their height
     this.$refs['accordion-group'].accordions.filter(a => a.active)
       .forEach(a => a.setContentHeight())
    },
    filterByLetter (letter) {
     this.product_name= this.selectedLetter = letter;
     this.isLetterSearch =  letter.trim() != '';


    },
    readArrays() {
      console.log(this.items);
    }
  }
}
</script>
<style lang="scss">
.flex-item {
  flex: 1 1 auto;

}
.grid-container {
  &__parent{
    @include mobile-only {
      float: left;
      width: 300px;
      overflow: auto;
      white-space: nowrap;
    }
    &::-webkit-scrollbar {
     display: none;
    }


  }

  &__inner {
    display:grid;
    display: grid;
    gap: 3px;
    grid-auto-flow: column;
    //grid-auto-columns: 1fr;
    grid-auto-columns: 23vmax;

     @include mobile-only {
      width: 830px;
      grid-auto-columns:30vmax;
     }
  }
}

.glossary-products {
  background: $color-black-050;
  /deep/ a{
    color: red;
  }
  .product-tile__static-text-content {
    position: unset;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .product-tile__images {
    height: 265px;
  }
}
  .glossary-items {
   margin-left: 155px;
   margin-right: 155px;
   margin-top: 40px;

   @include mobile-only {
      margin-left: 0;
      margin-right: 0;
   }

    &__wrapper {
      margin-top: 50px;
      height: 100%;
      max-width: 1441px;
      display: flex;
      column-gap: 37px;
      flex-direction: row;
       @include mobile-only {
        column-gap: 0px;
        margin-top: 0px;
      }
    }

    &__alphabates {
      flex: 1;
      margin-top: 48px;
      padding-left: 0px;

      @include mobile-only {
        margin-top: 0px;
      }

      ul {
          padding-left: 0px;
      }
      li {
        color: $color-black-600;
        font-size: 24px;
        letter-spacing: -0.16px;
        line-height: 50px;
        text-align: center;
        height: 60px;
        width: 60px;
        margin:0 auto;

        &:hover {
          box-sizing: border-box;
          border: 1px solid $color-black-900;
          border-radius: 32.5px;
        }

        &.active {
          box-sizing: border-box;
          border: 1px solid $color-black-900;
          border-radius: 32.5px;
        }
      }
      a {
        text-decoration: none;
      }
    }

    &__inner-body {
      flex: 10;
      margin-bottom: 50px;
      @include mobile-only {
        margin-top:20px;
      }

      .glossary-details{

        &__heading {
          letter-spacing: -0.08px;
          line-height: 48px;
          color: $color-black-600;
          @include mobile-only {
            font-size: 22px;
          }
        }
        &__description p{
          color: $color-black-700;
          font-size: 15px;
          letter-spacing: -0.1px;
          line-height: 23px;
        }
        &__view_all_link a{
          font-size: 18px;
          letter-spacing: 0.2px;
          line-height: 20px;
        }
      }

    }
    &__search-container {
      position: relative;
      margin-bottom: 48px;
      padding-left: 20px;
      padding-right: 20px;
      @include mobile-only {
        margin-bottom: 0px;
      }
    }
    &__icon {
      position: absolute;
      bottom: 0;
    }

    &__search-product{
      border: 0;
      border-bottom: 1px solid $color-black-600;
      background-color: transparent;
      padding-bottom: 0;
      padding-left: 25px;
      width: 100%;
      margin: 0;
      color: $color-black-600;
      font-size: 15px;
      letter-spacing: 0;
      line-height: 22px;
      &:focus {
        outline: none;
      }

    }
  }
  .is-open span.glossary-details__heading.h3 {
    color: $color-black-900;
  }
  .accordion__header {
    @include mobile-only {
      padding-top: 0px;
      padding-bottom: 0px;
    }
  }


</style>
